import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EditCommoditiesForm } from "web_myplann/Portfolio/Pages/CommoditiesEdit/EditCommoditiesForm";
import { PortfolioEditLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioEditLayout";

export const EditCommoditiesPage = () => {
	const { t } = useResource();

	return (
		<PortfolioEditLayout
			expectedDomain={ClientPortfolioDomainEnum.Commodities}
			title={t(Resources.Portfolio.EditPortfolio.title)}
		>
			{({ portfolio, portfolioId, detailRoute }) => (
				<EditCommoditiesForm
					portfolioId={portfolioId}
					portfolio={portfolio}
					detailRoute={detailRoute}
				/>
			)}
		</PortfolioEditLayout>
	);
};
